export default __webpack_public_path__ + "assets/images/5964cf37e3313b50f129bb9d87fed2ee.jpg";